import { mapState,mapActions } from 'vuex';

function pruneCacheEntry (
    cache,
    key,
    keys,
    current
  ) {
    const cached = cache[key]
    if (cached && (!current || cached.tag !== current.tag)) {
      cached.componentInstance.$destroy()
    }
    cache[key] = null
    remove(keys, key)
}

function remove (arr, item){
    if (arr.length) {
      const index = arr.indexOf(item)
      if (index > -1) {
        return arr.splice(index, 1)
      }
    }
}

function isDef (v){
    return v !== undefined && v !== null
}

function isAsyncPlaceholder (node){
    return node.isComment && node.asyncFactory
  }

function getFirstComponentChild(children){
    if (Array.isArray(children)) {
      for (let i = 0; i < children.length; i++) {
        const c = children[i]
        if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
          return c
        }
      }
    }
}



const keepAliveManager ={
    ...mapState('pages',[
        "opened",
        "current"
    ]),
    keepAlive:null,
    /**
     * 缓存已经打开的路由(keepAlive节点)
     *  
     * */    
    cachekeepAliveVnode:{},

    //keepAlive 节点与路由名的映射
    keepAliveMap:{},

    //已打开的tab选项
    tabItemObject:undefined,

    /**
     * 路由跳转
     */
    pushRouter(thiz,routeObj){ 
        if(!routeObj){
            return;
        }       
        if(this.keepAlive&&this.keepAlive.componentInstance&&this.keepAlive.componentInstance.cache){
            let route=this.cachekeepAliveVnode[routeObj.name];
            if(route){
                let cachedVnode=route.vnode;
                this.clearCurrentVnodeCache(cachedVnode);

                this.cachekeepAliveVnode[routeObj.name]=null;

                //删除节点与路由名的映射
                delete this.keepAliveMap[route.key];
            }            
        }
        //路由调转
        thiz.$router.push(routeObj);        
    },

    /**
     * 关闭当前页返回源路由页
     *      */
    backSourceRoute(thiz,skipRouteObj){
        if(!thiz||!skipRouteObj){
            return ;
        }
        if(thiz.$vnode==undefined){
            return;
        } 
        let _vnode=thiz.$vnode;
        if(!this.tabItemObject){
            return;
        }       
        if(!this.keepAlive){
           return;
        }
        if(this.keepAlive.componentInstance==undefined){
             return;
        }
        if(this.keepAlive.componentInstance.cache==undefined){
             return;
        }
        //虚拟节点被keepAlive组件管理
        if(!_vnode.data.keepAlive){
            return;
        }
        //根据路由名缓存keepalive中的组件
        let currentKey;
        if(_vnode.key==null){
             currentKey=_vnode.componentOptions.Ctor.cid;
        }else{
             currentKey=_vnode.key;
        }

        //获取路由名
        let currentRouteName=this.keepAliveMap[currentKey];
        
        //回到目标路由页上
        this.tabItemObject.backTargetTab(currentRouteName,skipRouteObj);
    },

    /**
     * 缓存路由组件
     * @param {*} to 
     * @param {*} from 
     * @param {*} next 
     */ 
    cacheKeepaliveSubNode(routeName,_vnode){
       if(_vnode==undefined){
           return;
       }
       if(!this.keepAlive){
          return;
       }
       if(this.keepAlive.componentInstance==undefined){
            return;
       }
       if(this.keepAlive.componentInstance.cache==undefined){
            return;
       }
       //虚拟节点被keepAlive组件管理
       if(!_vnode.data.keepAlive){
           return;
       }
       //根据路由名缓存keepalive中的组件
       let currentKey;
       if(_vnode.key==null){
            currentKey=_vnode.componentOptions.Ctor.cid;
       }else{
            currentKey=_vnode.key;
       }
       
       let route=this.cachekeepAliveVnode[routeName];
       
       if(route){
         if(this.keepAliveMap[route.key]){
             delete this.keepAliveMap[route.key];
         }
       }

       //实现路由名与节点Key的双向映射
       this.cachekeepAliveVnode[routeName]={
         vnode:_vnode,
         key:currentKey
       };
       this.keepAliveMap[currentKey]=routeName;
    },
    /**
     * 根据key销毁节点与路由的映射关系
     */
    destroyCacheMapForKey(keyItem){
        //删除路由到节点key的双向映射
        let keyRoutMap=this.keepAliveMap[keyItem];
        if(keyRoutMap){
            delete this.cachekeepAliveVnode[keyRoutMap.name]
        }
    },
    /**
     * Tab页关闭时（在路由切换离开前），清除当前组件缓存
     * @param {} _vnode 
     */
    clearCurrentVnodeCache(_vnode){
       // debugger;
       if(_vnode==undefined){
           return;
       }
       if(!this.keepAlive){
          return;
       }
       if(this.keepAlive.componentInstance==undefined){
            return;
       }
       if(this.keepAlive.componentInstance.cache==undefined){
            return;
       }
       //虚拟节点被keepAlive组件管理
       if(!_vnode.data.keepAlive){
           return;
       }
       //const currentVnode=getFirstComponentChild(this.keepAlive.componentInstance.$slots.default);
       //缓存组件集合
       let cache=this.keepAlive.componentInstance.cache;
       let keysOfCache=Object.keys(cache);
       let keys=this.keepAlive.componentInstance.keys;
        

       //keepAlive下的缓存组件key
       let currentKey;
       if(_vnode.key==null){
            currentKey=_vnode.componentOptions.Ctor.cid;
       }else{
            currentKey=_vnode.key;
       }
       let isHas=keysOfCache.some(item=>item==currentKey);
       if(isHas){
          //删除缓存
          let clearKeys=keysOfCache.filter(item=>item==currentKey);
          let cachedObj;
          let keyRoutMap;
          clearKeys.forEach((keyItem)=>{
                //删除路由到节点key的双向映射
                this.destroyCacheMapForKey(keyItem);
                
                //销毁
                cachedObj=cache[keyItem];                
                cachedObj.componentInstance.$destroy()
                delete cache[keyItem];
                if (keys.length) {
                    let index = keys.indexOf(keyItem)
                    if (index > -1) {
                       keys.splice(index, 1)
                    }
                }
          });
       }
    },
    clearAllCache(){
       // debugger;
       if(!this.keepAlive){
          return;
       }
       if(this.keepAlive.componentInstance==undefined){
           return;
       }
       if(this.keepAlive.componentInstance.cache==undefined){
           return;
       }
       //缓存组件集合
       let caches=this.keepAlive.componentInstance.cache;
       // let keysOfCache=Object.keys(cache);
       let keys=this.keepAlive.componentInstance.keys;
       let cached;
       for (const key in caches) {
          cached =caches[key]
          if (cached) {
              //删除路由到节点key的双向映射
              this.destroyCacheMapForKey(key);

              cached.componentInstance.$destroy();
          }          
          delete caches[key];
          if (keys.length) {
            const index = keys.indexOf(key)
            if (index > -1) {
               keys.splice(index, 1)
            }
          }
       }
    //    keysOfCache.forEach((keyItem)=>{
    //        delete cache[keyItem];
    //    });
       return this;
    },
    clearOtherCache(){
        if(!this.keepAlive){
            return;
        }
        if(this.keepAlive.componentInstance==undefined){
            return;
        }
        if(this.keepAlive.componentInstance.cache==undefined){
            return;
        }
        const currentVnode=getFirstComponentChild(this.keepAlive.componentInstance.$slots.default);

        if(!currentVnode){
            return;
        }
        const currentKey=currentVnode.key == null
                         ? currentVnode.componentOptions.Ctor.cid + (currentVnode.componentOptions.tag ? `::${currentVnode.componentOptions.tag}` : '')
                         : currentVnode.key;
        
        
         //缓存组件集合
         let caches=this.keepAlive.componentInstance.cache;
         // let keysOfCache=Object.keys(cache);
         let keys=this.keepAlive.componentInstance.keys;
         let cached;
         for (const key in caches) {
            if(currentKey==key){
               continue;
            }
            cached =caches[key]
            if (cached) {
                //删除路由到节点key的双向映射
                this.destroyCacheMapForKey(key);

                cached.componentInstance.$destroy();
            }          
            delete caches[key];
            if (keys.length) {
              const index = keys.indexOf(key)
              if (index > -1) {
                 keys.splice(index, 1)
              }
            }
         }
    }
}


keepAliveManager.install = function (Vue) {
    Vue.prototype.$keepAliveManager = keepAliveManager;
}

export default keepAliveManager;